import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconClose } from 'components/Icons';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
  }

  handleClose() {
    this.props.onClose();
  }

  handleOutsideClick(e) {
    e.preventDefault();
    this.handleClose();
  }

  handleKeyDown(e) {
    let ESC = 27;
    if (e.keyCode === ESC) {
      this.handleClose();
    }
  }

  render() {
    return (
      <div className="syos-modal-container">
        <div
          className="syos-modal-backdrop"
          role="presentation"
          tabIndex="-1"
          onClick={this.handleOutsideClick}
        />
        <div className="syos-modal" role="dialog">
          <div className="syos-modal__header">
            <button
              className="syos-modal__close"
              aria-label="Close"
              onClick={this.handleClose}
              tabIndex="0"
            >
              <IconClose />
            </button>
            {this.props.title && (
              <h4 className="syos-modal__title">{this.props.title}</h4>
            )}
          </div>
          <div className="syos-modal__body">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default Modal;



// WEBPACK FOOTER //
// ./src/javascripts/components/Modal.js